export default __webpack_public_path__ + "media/images/icon_flag-caa9d4017a313647773fb4e98762ae3c.svg";